import config from "../config.json";
import { apiClient, getAccessToken, getUserEmail } from "./apiClient";

// const SendMailByTemplate = async (reqFormData) => {
//   const token = await getAccessToken();
//   let url = `${config.API_URL}/emails/requests/send`;

//   let headers = {
//     "Content-Type": "application/x-www-form-urlencoded",
//     Authorization: `Bearer ${token}`,
//     User: getUserEmail(),
//   };
  
//   try {
//     return await apiClient.post(url, reqFormData, {
//       headers,
//       timeout: config.API_CONNECTION_TIMEOUT,
//     });
//   } catch (error) {
//     throw error;
//   }
// };

const SendMailByTemplate = async (req) => {
  const token = await getAccessToken();
  let url = `${config.API_URL}/emails/requests/send`;

  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  
  try {
    return await apiClient.post(url, JSON.stringify(req), {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    throw error;
  }
};


const MailService = {
  SendMailByTemplate,
};

export default MailService;
